<template>
  <div>
    <template v-if="errors.code">
      <a-result :status="String(errors.code)" :title="errors.code" :sub-title="errors.message">
        <template #extra>
          <a-button type="primary" @click="$router.back()">
            {{ $t('utils.back') }}
          </a-button>
        </template>
      </a-result>
    </template>
    <template v-else>
      <div
        class="mb-4"
        style="position: sticky; top: 78px; z-index: 5; background-color: white; margin: -20px -35px 0; padding: 15px 30px;"
      >
        <a-breadcrumb
          separator=">"
        >
          <a-breadcrumb-item>
            <router-link :to="{ path: '/product', query: { business_id: businessId, workspace_id: $route.query.workspace_id } }">
              {{ $t('product.title') }}
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <router-link :to="{ path: '/product', query: { business_id: businessId, workspace_id: $route.query.workspace_id } }">
              {{ $t('product.listProduct') }}
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            {{ business.business_title }}
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            {{ $t('web_platform.product.edit_product') }}
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>

      <CreateProductForm
        ref="form"
        :business="business"
        :product="product"
        :permission="permission"
      />
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import CreateProductForm from './components/form/index.vue'

export default defineComponent({
  name: 'EditProductPage',
  components: { CreateProductForm },
  beforeRouteLeave(to, from, next) {
    return this.$refs.form ? this.$refs.form.beforeRouteLeave(to, from, next) : next()
  },
  data() {
    return {
      product: null,
      errors: {
        message: null,
        code: null,
      },
    }
  },
  computed: {
    productId() {
      const id = this.$route.params.productId
      return Array.isArray(id) ? id.join(',') : id
    },
    channelId() {
      return String(this.$route.params.id)
    },
    
    /**
     * @returns {string}
     */
    businessId() {
      return String(this.$route.query['business_id'] || '')
    },

    /**
     * @returns {import('@/types/utils').Business}
     */
    business() {
      return this.$store.state.user.businessList.find(business => business.business_id === this.businessId) || {}
    },
    permission() {
      return this.$store.getters['user/can']('product-master')
    },
  },
  // watch: {
  //   permission(newValue) {
  //     if(!newValue.length) {
  //       this.$router.push({path: '/error/403', query: {...this.$route.query}})
  //     }
  //   },
  // },
  mounted() {
    this.$store.commit('products/SET_CHANNEL', false)
    this.getProductDetail()
  },
  methods: {
    async getProductDetail() {
      if (!this.productId) return

      this.errors.message = null
      
      try {
        this.product = await this.$store.dispatch('web_platform_channel/products/GET_PRODUCT', {
          id: this.productId,
          channel_id: this.channelId,
          business_id: this.businessId,
        })
      } catch (err) {
        const code = err.response?.status
        this.errors.code = code
        this.errors.message = code === 404 ? this.$t('web_platform.product.draft.product_not_found') : (err.response?.data?.message || this.$t('web_platform.product.draft.error_occurred'))
      }
    },
  },
})
</script>
